import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizationsListComponent } from './components/authorizations-list/authorizations-list.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonDetailsViewComponent } from 'src/app/shared/components/prescription-authorization-common/common-details-view/common-details-view.component';


const routes: Routes = [
  { path: 'authorizationslist', component: AuthorizationsListComponent},
  { path: 'detail-view/:id', component: CommonDetailsViewComponent},
  { path: '**', redirectTo: 'authorizationslist' },
]

@NgModule({
  declarations: [
    AuthorizationsListComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ]
})
export class AuthorizationModule { }
